import React,{useState,useEffect} from "react";
import { FormikProvider, useFormik, Form } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import {
  Button,
  CardContent,
  CardActions,
  Card,
  TextField,
  Grid,
  Typography,

} from "@mui/material";
import { Post, apiURL , Put, Get} from "../../../../utils/apiCalls";
import { LoadingButton } from "@mui/lab";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
const AdminSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string().required("Description is required"),
    lat: Yup.string()
    .required('Latitude is required')
    .test('is-latitude', 'Latitude must be a number between -90 and 90', (value) => {
      if (!value) return false;
      const num = Number(value);
      return !isNaN(num) && num >= -90 && num <= 90;
    }),
    lag: Yup.string()
    .required('Longitude is required')
    .test('is-longitude', 'Longitude must be a number between -180 and 180', (value) => {
      if (!value) return false;
      const num = Number(value);
      return !isNaN(num) && num >= -180 && num <= 180;
    }),
});


const MapEditCreate = () => {
    const navigate = useNavigate();
    const [mapDetail, setMapDetail] = useState({ name:'',description:'',lag:'',lat:''})
    const { id } = useParams();

async function GetList () {
  const response = await Get(apiURL + '/api/v1/map_project_locations/' , id);
       if(response) {
      if (response.data.status) {       
        setMapDetail(response.data.data)
      }
      else {
      toast.error(response.data.message)
      setMapDetail({}) 
      }
    }
    else {
      // setLoading(false);
    }
};
useEffect(()=> {
 if(id){
  GetList()
 }
},[id]);

  const formik = useFormik({
    initialValues: {
     ...mapDetail
    },
    validationSchema: AdminSchema,
    enableReinitialize:true,
    onSubmit: async (values, { setSubmitting }) => {
      const response = id ? await Put(apiURL + "/api/v1/map_project_locations/",id, {
        ...values
      }):await Post(apiURL + "/api/v1/map_project_locations/", {
        ...values
      }); 
      if (response && response.data && response.status) {
        toast.success("map Updated Sucessfully");
        setSubmitting(false);
        navigate(`/dashboard/MapList`)
      } else {
        toast.error(response?.data.message || "Please Try Again");
        setSubmitting(false);
      }
    },
  });
  
  const {
    errors,
    touched,
    values,
    setFieldValue,
    isSubmitting,
    handleSubmit,
    getFieldProps,
    resetForm,
  } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Card>
          <CardContent>
            <Typography align="center" variant="h4">
              EDIT MAP
            </Typography>
            <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Name"
                  {...getFieldProps("name")}
                  error={Boolean(touched.name && errors.name)}
                  helperText={touched.name && errors.name}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Description"
                  {...getFieldProps("description")}
                  error={Boolean(touched.description && errors.description)}
                  helperText={touched.description && errors.description}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Latitude"
                  {...getFieldProps("lat")}
                  error={Boolean(touched.lat && errors.lat)}
                  helperText={touched.lat && errors.lat}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Longitude"
                  {...getFieldProps("lag")}
                  error={Boolean(touched.lag && errors.lag)}
                  helperText={touched.lag && errors.lag}
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Button
              onClick={(e) =>
                navigate(-1)
              }
              variant="contained"
              sx={{
                backgroundColor: "#3f51b5",
                "&:hover": { color: "#ffff", backgroundColor: "#3f51b5" },
              }}
            >
              Back
            </Button>
            <LoadingButton
              size="large"
              type="submit"
              variant="contained"
              loading={isSubmitting}
              sx={{
                backgroundColor: "#3f51b5",
                "&:hover": { color: "#ffff", backgroundColor: "#3f51b5" },
              }}
            >
              Save{" "}
            </LoadingButton>
          </CardActions>
        </Card>
      </Form>
    </FormikProvider>
  );
};

export default MapEditCreate;